import CMSection from '@src/components/Atoms/CMSection';
import { devices } from '@src/styles/theme';
import Image from 'next/image';
import styled from 'styled-components';

const Second = () => {
  return (
    <CMSection backgroundColor="#F9F9F9">
      <Wrap>
        <ImageWrap height={'478px'}>
          <SecondImage
            fill={true}
            src={'/imgs/sponser/second-1.svg'}
            alt="image"
          />
        </ImageWrap>
        <TextWrap margin={'80px 0 60px 0'}>
          <BigText>
            툭 하면 접하게 되는 <span>헌혈 부족</span> 뉴스...
          </BigText>
        </TextWrap>
        <TextWrap margin={'0 0 60px 0'}>
          <SmallText>
            국내 헌혈자는 지난해(22년도) 260만 명에 그쳤고 헌혈률은 100명당
            5명에 불과한 수준입니다.
            <br />
            저출생, 고령화로 인해 헌혈 가능 인구는 지속적으로 줄어들 것이며 혈액
            불균형은 더욱 심각해질 전망입니다.
          </SmallText>
        </TextWrap>
        <SecodeImageWrap>
          <Second_2Image
            fill={true}
            src={'/imgs/sponser/second-2.svg'}
            alt="image"
          />
          <Second_2_Mb_Image
            fill={true}
            src={'/imgs/sponser/second-2-mb.svg'}
            alt="image"
          />
        </SecodeImageWrap>
      </Wrap>
    </CMSection>
  );
};

const Wrap = styled.div`
  /* margin: 110px 0; */
  padding: 110px 0;
  @media ${devices.tablet} {
    padding: 50px 24px;
  }
`;

const ImageWrap = styled.div<{ height: string }>`
  position: relative;
  height: ${({ height }) => height};

  @media ${devices.tablet} {
    height: 211px;
  }
`;

const SecodeImageWrap = styled.div`
  position: relative;
  height: 576px;

  @media ${devices.tablet} {
    height: 282px;
  }
`;

const SecondImage = styled(Image)``;
const Second_2Image = styled(Image)`
  display: block;

  @media ${devices.tablet} {
    display: none;
  }
`;
const Second_2_Mb_Image = styled(Image)`
  border-radius: 15px;
  display: none;
  @media ${devices.tablet} {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

const TextWrap = styled.div<{ margin: string }>`
  margin: ${({ margin }) => margin};
  display: flex;
  align-items: center;
  justify-content: center;
  @media ${devices.tablet} {
    margin: 0 0 20px 0;
  }
`;

const BigText = styled.div<{ isActive?: boolean }>`
  color: ${({ theme }) => theme.commonColor.black};
  font-family: 'NOTO';
  font-size: 47px;
  font-style: normal;
  font-weight: 500;
  line-height: 65px;
  letter-spacing: -1.41px;
  > span {
    color: ${({ theme }) => theme.commonColor.pink005};
  }
  @media ${devices.tablet} {
    font-size: 22px;
    line-height: 36px;
    letter-spacing: -0.72px;
  }
`;

const SmallText = styled.div`
  max-width: 600px;
  color: ${({ theme }) => theme.commonColor.black};
  font-family: 'Var';
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px; /* 153.846% */
  white-space: pre-wrap;

  @media ${devices.tablet} {
    font-size: 16px;
    line-height: 24px; /* 150% */
  }
`;

export default Second;
